import { MACKINAC_XRPC_URL } from '@/constants/api'

const NSID = 'app.mackinac.publications.getSubscriberCount'

interface GetSubscriberCountResponse {
    count: number | null
}

export async function fetchSubscriberCount(publicationUri: string): Promise<number | null> {
    try {
        const params = new URLSearchParams({ publicationUri })
        const response = await fetch(`${MACKINAC_XRPC_URL}/xrpc/${NSID}?${params}`)
        if (!response.ok) return null

        const data = (await response.json()) as GetSubscriberCountResponse
        const count = data?.count
        if (typeof count === 'number' && Number.isSafeInteger(count) && count >= 0) return count
        return null
    } catch {
        return null
    }
}
